module.exports = __webpack_public_path__ + "static/media/SingleLegSquatFemale.3b8121d7.svg";